
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ContactsComponent } from './list/contacts.component';



import { ContactsProfileComponent } from './contacts-profile/contacts-profile.component';

const routes: Routes = [
  {
    path: '',
    component: ContactsComponent,

    data: { title: 'Contacts' },
  },
  {
    path: ':id/view',
    component: ContactsProfileComponent,
    data: { title: 'Contact Profile' }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ContactsRoutingModule { }
